var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 34,
    viewBox: "0 0 86 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_2832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.9996 2.44927H71.6846L72.561 0.0361328H85.9996V2.44927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8389 0.0361328H61.1314L62.0079 2.44927H47.8389V0.0361328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.285 0C39.4761 0.216102 41.375 0.972458 42.9818 2.41314H18.8799V0H37.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7253 0H0V2.41314H16.7253V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0004 6.98735H70.042L70.9184 4.57422H86.0004V6.98735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6512 6.98735H47.8389V4.57422H62.7747L63.6512 6.98735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8803 4.57422C45.209 5.36659 45.5742 6.05091 45.5742 6.98735H18.916V4.57422H44.8803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7253 4.57422H0V6.98735H16.7253V4.57422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3984 11.5254L69.2749 9.1123H81.2528V11.5254H68.3984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4182 9.1123L65.2946 11.5254H52.5498V9.1123H64.4182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7938 9.1123C45.7938 9.94069 45.6842 10.8051 45.4286 11.5254H38.125V9.1123H45.7938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8679 9.1123H4.67383V11.5254H11.8679V9.1123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9304 9.1123H23.7363V11.5254H30.9304V9.1123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6343 14.1188V15.9556H52.5498V13.5425H66.025L66.8649 15.7755L67.6683 13.5425H81.253V15.9556H74.205V14.1188L73.5477 15.9556H60.2551L59.6343 14.1188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 13.5425H44.3325C43.8943 14.3349 43.0544 15.3433 42.2875 15.9556H23.7363V13.5425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8679 13.5425H4.67383V15.9556H11.8679V13.5425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2531 18.0806H74.2051V20.4937H81.2531V18.0806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6343 18.0806H52.5498V20.4937H59.6343V18.0806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7803 18.0806C72.7438 18.0806 71.9404 20.4937 71.9039 20.4937H61.8979L61.0215 18.0806H72.7803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 18.0806H42.251C43.0909 18.7649 43.8578 19.6293 44.4786 20.4937H23.7363V18.0806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8679 18.0806H4.67383V20.4937H11.8679V18.0806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2531 22.6187H74.2051V25.0318H81.2531V22.6187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6343 22.6187H52.5498V25.0318H59.6343V22.6187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2973 25.0318L71.1737 22.6187H62.665L63.5415 25.0318H70.2973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 25.0318V22.6187H31.0399V25.0318H23.7363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5011 22.6187C45.8663 23.339 45.9028 24.2034 45.9758 25.0318H38.2705V22.6187H45.5011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8679 22.6187H4.67383V25.0318H11.8679V22.6187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0004 27.0488H74.2051V29.462H86.0004V27.0488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6342 27.0488H47.8389V29.462H59.6342V27.0488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6906 29.462H65.1118L64.2354 27.0488H69.5305L68.6906 29.462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 27.0488V29.462H16.7253V27.0488H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6837 27.0488C45.5012 27.8412 45.3551 28.8137 44.7708 29.462H18.916V27.0488H45.6837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0836 34.0001H66.755L65.915 31.5869H67.9235L67.0836 34.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0004 31.5869H74.2051V34.0001H86.0004V31.5869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.916 34.0001V31.5869H43.164C41.5207 33.0996 39.3296 33.964 36.9194 34.0001H18.916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6342 31.5869H47.8389V34.0001H59.6342V31.5869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7253 31.6229V34.0001H0V31.5869C0 31.6229 16.7253 31.6229 16.7253 31.6229Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_2832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHard1);
export default __webpack_public_path__ + "static/media/hard1.4f6a2825b6b2282b271cd90d90f723c2.svg";
export { ForwardRef as ReactComponent };